import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ItemNumberToFilterShared } from '../../../models/interface/itemNumberToFilter.interface';
import { FormControlValidatorService } from '../../../sharedServices/form-control-validator.service';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';
import { MuComponent } from '../../../types/MuComponent.componetent';

@Component({
  selector: 'app-mu-payment-add-pse',
  templateUrl: './mu-payment-add-pse.component.html',
  styleUrls: ['./mu-payment-add-pse.component.sass'],
})
export class MuPaymentAddPseComponent<ActionType, FlagType> extends MuComponent implements OnChanges {
  @Input() customClass = 'default-express-add-card-sizes';
  @Input() actionList: Actions<ActionType, any>;
  @Input() flagList: Flags<FlagType>;
  @Input() formData: UntypedFormGroup;
  @Input() userTypeList: ItemNumberToFilterShared[];
  @Input() documentTypeList: ItemNumberToFilterShared[];
  @Input() kushkiBankList: ItemNumberToFilterShared[];
  @Input() showFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() saveAction: ActionType;
  @Input() cancelAction: ActionType;
  @Input() skin: boolean;
  @Input() showVerificationDigit: boolean;

  constructor(private changeDetector: ChangeDetectorRef, private elementRef: ElementRef, private validator: FormControlValidatorService) {
    super();

    changeDetector.detach();
  }

  muOnDestroy(): void {
    document.body.removeChild(this.elementRef.nativeElement);
  }

  muOnInit(): void {
    setTimeout(() => this.changeDetector.reattach());
    document.body.appendChild(this.elementRef.nativeElement);
  }

  /**
   * Event emmit action save credit card
   */
  save(): void {
    this.actionList?.emit(this.saveAction, null);
  }

  /**
   * Event emmit action cancel pse
   */
  cancel(): void {
    this.actionList?.emit(this.cancelAction, null);
  }

  ngOnChanges(): void {
    if (!this.formData) {
      return environment.guardClause;
    }
  }
}
